import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Notification from './notification-model'
import {
  CreateNotificationAsync,
  DeleteNotificationAsync,
  LoadNotificationsAsync,
} from './notification-thunk'
const initialState: notificationSliceState = {
  notification: [],
  selected_notification: '',
  is_loading_notification: false,
  is_creating_notification: false,
  is_deleting_notification: false,
}
export interface notificationSliceState {
  notification: Notification[]
  selected_notification?: string
  is_loading_notification: boolean
  is_creating_notification: boolean
  is_deleting_notification: boolean
}
export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setSelectednotification: (state, action) => {
      state.selected_notification = action.payload
    },
    clearStatenotification: (state) => {
      state.notification = []
      state.is_loading_notification = false
      state.is_creating_notification = false
      state.is_deleting_notification = false
    },
    mergenotification: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_notification = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.notification = merge(state.notification, payload) as any
        }
      }
    },

    add_notification: (state, action) => {
      if (action.payload) {
        state.notification = [...state.notification, action.payload]
      }
    },
    set_notification: (state, action) => {
      let { key, value, id } = action.payload
      state.notification = state.notification.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadNotificationsAsync.pending, (state) => {
      state.is_loading_notification = true
    })
    builder.addCase(LoadNotificationsAsync.fulfilled, (state, action) => {
      state.is_loading_notification = false
      if (action.payload) {
        state.notification = action.payload
      }
    })
    builder.addCase(LoadNotificationsAsync.rejected, (state) => {
      state.is_loading_notification = false
    })
    builder.addCase(CreateNotificationAsync.pending, (state) => {
      state.is_creating_notification = true
    })
    builder.addCase(CreateNotificationAsync.fulfilled, (state) => {
      state.is_creating_notification = false
    })
    builder.addCase(CreateNotificationAsync.rejected, (state) => {
      state.is_creating_notification = false
    })
    builder.addCase(DeleteNotificationAsync.pending, (state) => {
      state.is_deleting_notification = true
    })
    builder.addCase(DeleteNotificationAsync.fulfilled, (state, action) => {
      state.is_deleting_notification = false
      if (state.notification) {
        state.notification = state.notification.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteNotificationAsync.rejected, (state) => {
      state.is_deleting_notification = false
    })
  },
})

export const {
  clearStatenotification,
  setSelectednotification,
  set_notification,
  mergenotification,
  add_notification,
} = notificationSlice.actions

export const get_notification =
  (id?: string) =>
  (state: {
    notification: {
      notification: Notification[]
    }
  }): Notification | null => {
    let temp = state?.notification?.notification?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.notification?.notification[0] || null
  }
export const get_selected_notification = (state: {
  notification: notificationSliceState
}): Notification | null => {
  let id = state?.notification?.selected_notification
  let temp = state?.notification?.notification?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_notification = (state: {
  notification: {
    notification: Notification[]
  }
}): Notification[] => {
  let temp = state?.notification?.notification
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_notification_busy = (state: {
  notification: notificationSliceState
}) => {
  return (
    state?.notification.is_deleting_notification ||
    state?.notification.is_loading_notification ||
    state?.notification.is_creating_notification
  )
}
export const is_deleting_notification_busy = (state: {
  notification: notificationSliceState
}) => {
  return state?.notification.is_deleting_notification
}
export const is_loading_notification_busy = (state: {
  notification: notificationSliceState
}) => {
  return state?.notification.is_loading_notification
}
export const is_creating_notification_busy = (state: {
  notification: notificationSliceState
}) => {
  return state?.notification.is_creating_notification
}

export default notificationSlice.reducer
